/**
 * @generated SignedSource<<a170ceece1a10f48b023e47867d056de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContent_user">;
  readonly " $fragmentType": "HpSharedFeaturedModule_user";
};
export type HpSharedFeaturedModule_user$key = {
  readonly " $data"?: HpSharedFeaturedModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModule_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2d2cfb3f497bdd57a9bf7899bfb03c48";

export default node;
